var _rect, _rect2, _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 128,
    viewBox: "0 0 170 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 28)",
    fill: "#29B2EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 20)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1_399)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 80,
    rx: 30,
    ry: 10,
    fill: "#29B1EA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3333 33.3334C67.8105 33.3334 63.3333 28.8562 63.3333 23.3334C63.3333 17.8105 67.8105 13.3334 73.3333 13.3334C78.8562 13.3334 83.3333 17.8105 83.3333 23.3334C83.3333 28.8562 78.8562 33.3334 73.3333 33.3334Z",
    fill: "url(#paint0_linear_1_399)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3333 36.6666C82.5383 36.6666 90 43.9416 90 52.9166V69.7216C90 71.7166 88.3433 73.3333 86.2967 73.3333H60.37C58.3233 73.3333 56.6667 71.7166 56.6667 69.7216V52.9166C56.6667 43.9416 64.1283 36.6666 73.3333 36.6666Z",
    fill: "url(#paint1_linear_1_399)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6667 26.6666C91.1438 26.6666 86.6667 22.1895 86.6667 16.6666C86.6667 11.1438 91.1438 6.66663 96.6667 6.66663C102.19 6.66663 106.667 11.1438 106.667 16.6666C106.667 22.1895 102.19 26.6666 96.6667 26.6666Z",
    fill: "url(#paint2_linear_1_399)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6667 30C105.872 30 113.333 37.275 113.333 46.25V69.7217C113.333 71.7167 111.677 73.3333 109.63 73.3333H83.7033C81.6567 73.3333 80 71.7167 80 69.7217V46.25C80 37.275 87.4617 30 96.6667 30Z",
    fill: "url(#paint3_linear_1_399)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_399",
    x: 31,
    y: 46,
    width: 108,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1_399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_399",
    x1: 80.1167,
    y1: 16.5484,
    x2: 66.165,
    y2: 30.5017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EA2E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_399",
    x1: 77.8217,
    y1: 38.265,
    x2: 70.045,
    y2: 77.1416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EA2E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_399",
    x1: 103.45,
    y1: 9.88163,
    x2: 89.4983,
    y2: 23.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D61A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_399",
    x1: 101.762,
    y1: 31.895,
    x2: 92.68,
    y2: 77.3033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D61A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleTile);
export default __webpack_public_path__ + "static/media/peopleTile.f393094cacaec39a5d9b1615d9cc0f0b.svg";
export { ForwardRef as ReactComponent };